import handIcon from "../assets/images/icons/hand.svg";
import taskFrame from "../assets/images/icons/Rectangle 12.svg";
import LegacyActivityLayout from "../components/LegacyActivityLayout";
import { useTranslation } from "../components/Localization";

export default function LegacyCrestTaskPage() {
  const { t } = useTranslation();
  return <LegacyActivityLayout taskKey="crest" step={1} progressIcon="center" backTo="/mariaffiek/peter" nextTo="/mariaffiek/menekules/jatek">
    <button className="task-icon-button legacy-crest" aria-label={t("accessibility.crestPuzzle")}><img className="task-frame" src={taskFrame} alt="" /><img className="task-symbol legacy-crest-symbol" src={handIcon} alt="" /></button>
  </LegacyActivityLayout>;
}
